import axios from '@/shared/utils/axios-init';

const initialState = {
  historyData: [],
};


const getters = {
  getHistoryData(state) {
    return state.historyData;
  },
};

const mutations = {
  setHistoryData(state, data) {
    state.historyData = data;
  },
};

const actions = {
  async fetchHistoryData({ commit }, currencies) {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      const data = await axios.post('/deals',
        {
          base: currencies.baseCurrency,
          quoted: currencies.quoteCurrency },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

      const historyData = data.data.deals.list;

      commit('setHistoryData', historyData);

      return data;
    } catch (error) {
      commit('setHistoryData', []);
      return error.response;
    }
  },
};


export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/modules/Dashboard/modules/history.js